import { render, staticRenderFns } from "./ExpressOrderCreationUser.vue?vue&type=template&id=00e2360b&scoped=true"
import script from "./ExpressOrderCreationUser.vue?vue&type=script&lang=js"
export * from "./ExpressOrderCreationUser.vue?vue&type=script&lang=js"
import style0 from "./ExpressOrderCreationUser.vue?vue&type=style&index=0&id=00e2360b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e2360b",
  null
  
)

export default component.exports